"use client";

import React from "react";
import { Diamond } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  title: "PLAN: STRATEGIC DESIGN",
  description: "Utilize AI-driven insights to architect robust trading frameworks tailored to your specific risk profile and market objectives with institutional precision."
}, {
  title: "ACT: PRECISION EXECUTION",
  description: "Execute with systematic discipline, removing emotional friction through automated alerts and rules-based entry parameters for consistent outcomes."
}, {
  title: "LEARN: ITERATIVE REFINEMENT",
  description: "Analyze historical performance data to continuously optimize your strategies, ensuring survival and growth in rapidly evolving global markets."
}, {
  title: "EVOLVE: UNIFIED INTELLIGENCE",
  description: "Integrate proprietary data streams with the Caddie AI to maintain a constant edge over institutional competitors through systematic simplification."
}];
export default function MethodologyPillars() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="116874" id="the-methodology" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl relative z-10">
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-sans text-3xl md:text-4xl font-bold tracking-[0.25em] text-foreground uppercase">
            The Macaroni Methodology
          </h2>
          <div className="w-[80px] h-px bg-primary mt-6"></div>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 gap-6 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {pillars.map((pillar, i) => <Card key={i} data-index={i} className="group relative rounded-none bg-card border border-border/10 overflow-hidden transition-all duration-500 hover:bg-white/[0.02]">
              {}
              <div className="absolute top-0 left-0 w-full h-[2px] bg-transparent group-hover:bg-primary transition-colors duration-500 z-10" />

              <CardHeader className="px-8 pt-10 pb-4 relative z-10">
                <Diamond className="text-primary fill-primary size-5 mb-6 opacity-90" />
                <CardTitle className="font-sans text-[22px] font-bold tracking-tight text-foreground">
                  {pillar.title}
                </CardTitle>
              </CardHeader>
              
              <CardContent className="px-8 pb-10 pt-0 relative z-10">
                <p className="font-serif text-[15px] text-foreground/80 leading-[1.8]">
                  {pillar.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}